import React from 'react'

import { FormItem } from '@react/react-spectrum/Form'
import Heading from '@react/react-spectrum/Heading'
import Textfield from '@react/react-spectrum/Textfield'
import MediaUpload from 'components/MediaUpload'
import ColorInput from 'components/ColorInput'

export default function ({ branding, project, onChange, disabled }) {
  return (
    <>
      <section>
        <Heading size='4'>Logo</Heading>

        <MediaUpload
          type='image'
          value={branding.logo}
          heading='Drag and Drop'
          onUpload={onChange('logo')}
          projectId={project?.meta?.id}
          path={'branding-logo'}
          withTextfield={true}
          disabled={disabled}
        />
      </section>

      <section>
        <Heading size='4'>Colors</Heading>

        <FormItem label='Primary Color'>
          <ColorInput
            placeholder='Primary Color'
            name='primaryColor'
            value={branding.primaryColor}
            onChange={onChange('primaryColor')}
            disabled={disabled}
          />
        </FormItem>

        <FormItem label='Secondary Color'>
          <ColorInput
            placeholder='Secondary Color'
            name='secondaryColor'
            value={branding.secondaryColor}
            onChange={onChange('secondaryColor')}
            disabled={disabled}
          />
        </FormItem>

        <FormItem label='Background Color'>
          <ColorInput
            placeholder='Background Color'
            name='backgroundColor'
            value={branding.backgroundColor}
            onChange={onChange('backgroundColor')}
            disabled={disabled}
          />
        </FormItem>

        <FormItem label='Primary Text Color'>
          <ColorInput
            placeholder='Primary Text Color'
            name='primaryTextColor'
            value={branding.primaryTextColor}
            onChange={onChange('primaryTextColor')}
            disabled={disabled}
          />
        </FormItem>
      </section>
    </>
  )
}
